import { render, staticRenderFns } from "./TrialReadinessStatement.vue?vue&type=template&id=251cb5b8"
import script from "./TrialReadinessStatement.vue?vue&type=script&lang=ts"
export * from "./TrialReadinessStatement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports